import { render } from "./PartCourseContent.vue?vue&type=template&id=319ca022&scoped=true"
import script from "./PartCourseContent.vue?vue&type=script&lang=js"
export * from "./PartCourseContent.vue?vue&type=script&lang=js"

import "./PartCourseContent.vue?vue&type=style&index=0&id=319ca022&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-319ca022"]])

export default __exports__